module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      },
      "right-options": {
        showMore: true
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.titleTxt) + "\n\t\t")]), _vm._v(" "), _c('toast', {
    staticClass: "zjwToast",
    attrs: {
      "type": _vm.tipType,
      "width": "4.5rem",
      "text": _vm.tiptxt,
      "time": 1800,
      "is-show-mask": "",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  }), _vm._v(" "), (_vm.getBox == "1") ? _c('div', [_c('p', {
    staticClass: "forget-tips"
  }, [_vm._v("请输入您的登录账号，以进行密码重设")]), _vm._v(" "), _c('div', {
    staticClass: "sign-form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "已验证邮箱/注册手机号",
      "regtext": "请输入邮箱或手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item forget-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgNum),
      expression: "imgNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "maxlength": "6",
      "regtext": "请输入验证码"
    },
    domProps: {
      "value": (_vm.imgNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "alt": "验证码"
    },
    on: {
      "click": _vm.getSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "下一步"
    },
    on: {
      "click": _vm.nextOne
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.getBox == "2") ? _c('div', [(_vm.showP == "8") ? _c('div', [_c('group', [_c('x-switch', {
    attrs: {
      "title": _vm.txt
    },
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  })], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "menus": _vm.menus2,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.click
    },
    model: {
      value: (_vm.show2),
      callback: function($$v) {
        _vm.show2 = $$v
      },
      expression: "show2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showTel == 7) ? _c('div', [_c('group', [_c('cell', {
    attrs: {
      "title": "通过手机找回",
      "value": _vm.telNum,
      "is-link": ""
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticClass: "middle",
    attrs: {
      "type": "primary",
      "disabled": _vm.pcodebtn,
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCode("phone")
      }
    }
  }, [_vm._v(_vm._s(_vm.pcodetxt))]), _vm._v(" "), _c('div', {
    staticClass: "sign-form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeNum),
      expression: "codeNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.codeNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "下一步"
    },
    on: {
      "click": _vm.checkCode
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTel == 6) ? _c('div', [_c('group', [_c('cell', {
    attrs: {
      "title": "通过邮箱找回",
      "value": _vm.emailNum,
      "is-link": ""
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticClass: "middle",
    attrs: {
      "type": "primary",
      "disabled": _vm.ecodebtn,
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCode("email")
      }
    }
  }, [_vm._v(_vm._s(_vm.ecodetxt))]), _vm._v(" "), _c('div', {
    staticClass: "sign-form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeNum),
      expression: "codeNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.codeNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "下一步"
    },
    on: {
      "click": _vm.checkCode
    }
  })])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getBox == "3") ? _c('div', [_c('div', {
    staticClass: "sign-form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [(!_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "pass-display pass-show",
    class: {
      'pass-show': !_vm.passShow, 'pass-hide': _vm.passShow
    },
    on: {
      "click": _vm.changePassDisplay
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [(!_vm.passShow1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkpassword),
      expression: "checkpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入入密码"
    },
    domProps: {
      "value": (_vm.checkpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkpassword = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passShow1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkpassword),
      expression: "checkpassword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请再次输入入密码"
    },
    domProps: {
      "value": (_vm.checkpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkpassword = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "pass-display pass-show",
    class: {
      'pass-show': !_vm.passShow1, 'pass-hide': _vm.passShow1
    },
    on: {
      "click": _vm.changePassDisplay1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "重置密码"
    },
    on: {
      "click": _vm.setPsd
    }
  })])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8a1666","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/forget.vue
// module id = Sgtz
// module chunks = 1